import templateStr from 'text!./reassign-activity.html';

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            activity: '=',
            disable: '='
        },
        controller: ['$scope', 'ActivityService', 'ModalService', '$q', ($scope, ActivityService, ModalService, $q) => {
            let editable = false;
            $scope.disable = $scope.disable || false;
            $scope.assignedUser = null;

            $scope.isEditable = () => {
                return editable && !$scope.disable;
            };

            $scope.assignedUser = '';
            $scope.initialUser = $scope.activity.assignedUser;


            $scope.enableEditing = () => {
                // !disable to disallow enabling editing when directive is disabled
                // otherwise 1. click disabled directive, 2. enable directive, 3. editing starts immediately
                if ($scope.activity.canReassign && !$scope.disable) {
                    editable = true;
                }
            };

            $scope.disableEditing = () => {
                editable = false;
                $scope.assignedUser = '';
            };

            // Disable editing when directive enters disabled state, otherwise re-enabling activity puts it into edit state
            $scope.$watch('disable', (isDisabledNow) => {
                if (isDisabledNow) {
                    $scope.disableEditing();
                }
            });

            $scope.assignToSelectedUser = () => {
                const reassignActivityPromise = ActivityService.reassignActivity($scope.assignedUser, $scope.activity.publicID);
                $scope.reassignActivityPromise = reassignActivityPromise;

                $scope.disableEditing();
                $q.when(
                    reassignActivityPromise,
                    (activity) => {
                        angular.merge($scope.activity, activity);
                    },
                    (error) => {
                        ModalService.showError('gateway.directives.reassign-activity.Unable to reassign', error.baseError.data.error.message);
                    }
                );
            };
        }]
    };
};
